/** Délai par défaut si aucune variable d’environnement (fallback code). */
export const DEFAULT_SELLER_PAYOUT_HOURS = 72;

/**
 * Délai effectif côté front — lit `REACT_APP_SELLER_PAYOUT_HOURS` (build Vercel).
 * Doit être identique à `SELLER_PAYOUT_HOURS` côté API pour cohérence affichage / litiges.
 */
export function resolveSellerPayoutHours(envValue) {
  const n = Number(envValue);
  if (!Number.isFinite(n)) return DEFAULT_SELLER_PAYOUT_HOURS;
  return Math.max(0, n);
}

export const SELLER_PAYOUT_HOURS = resolveSellerPayoutHours(
  typeof process !== "undefined" ? process.env.REACT_APP_SELLER_PAYOUT_HOURS : undefined,
);

/** @deprecated Utiliser SELLER_PAYOUT_HOURS ; conservé pour anciennes configs env. */
export const DEFAULT_SELLER_PAYOUT_BUSINESS_DAYS = 3;

/**
 * Ajoute n heures calendaires (UTC).
 */
export function addHoursUtcIso(fromInput, hours) {
  const from = fromInput instanceof Date ? fromInput : new Date(fromInput);
  const h = Math.max(0, Number(hours) || 0);
  return new Date(from.getTime() + h * 3600 * 1000).toISOString();
}

/**
 * Ajoute n jours ouvrés (lundi–vendredi UTC), sans week-end.
 */
export function addBusinessDaysUtcIso(fromInput, businessDays) {
  const from = fromInput instanceof Date ? fromInput : new Date(fromInput);
  const d = new Date(Date.UTC(from.getUTCFullYear(), from.getUTCMonth(), from.getUTCDate(), 12, 0, 0));
  let count = 0;
  const n = Math.max(0, Number(businessDays) || 0);
  while (count < n) {
    d.setUTCDate(d.getUTCDate() + 1);
    const day = d.getUTCDay();
    if (day !== 0 && day !== 6) count += 1;
  }
  return d.toISOString();
}
